import { Modal } from "./Modal";
import { BrandHorizontal } from "./BrandEmblem";
import { LEADERSHIP_NAMED, LEADERSHIP_OPEN_ROLES } from "../../data/content";

export const AboutModal = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} wide testId="about-modal">
    <div className="p-8 md:p-12">
      <div className="flex flex-col gap-3">
        <BrandHorizontal className="h-20 w-auto self-start" />
        <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold mt-2">About Us</p>
      </div>
      <div className="mt-8 space-y-5 text-[#64748B] leading-relaxed">
        <p>
          Acuity Rise Education Group LLC — operating functionally as Acuity Rise Professional Services — is a
          professional services firm architecting reliable pathways to clinical excellence: delivering clinical
          education infrastructure and workforce development to the institutions that train and deploy the
          healthcare workforce.
        </p>
        <div className="bg-[#F8FAFC] border-l-2 border-[#D4AF37] rounded-r-xl p-5" data-testid="executive-bio">
          <p className="font-serif text-lg text-[#0B1B2B] font-semibold">Executive Leadership</p>
          <p className="mt-2 text-sm">
            Acuity Rise is led by a healthcare workforce strategist with 20+ years directing nursing programs and
            engineering self-sustaining clinical education frameworks, overseeing the firm's placement pod
            architecture, credentialing pipelines, and institutional partnership strategy.
          </p>
        </div>
        <p>
          From graduate nursing programs and FQHCs to pediatric facilities, homecare networks, vocational nursing schools, preceptors,
          and international medical graduates pursuing U.S. clinical experience — every engagement is governed by
          executive-grade rigor, encrypted document stewardship, and measurable institutional outcomes.
        </p>

        <div data-testid="leadership-section">
          <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold">Leadership Team</p>
          <div className="mt-4 space-y-4">
            {LEADERSHIP_NAMED.map((p) => (
              <div key={p.name} className="bg-[#F8FAFC] border-l-2 border-[#D4AF37] rounded-r-xl p-5" data-testid={`leader-${p.title.replace(/\s+/g, "-").toLowerCase()}`}>
                <p className="font-serif text-lg text-[#0B1B2B] font-semibold">{p.name}</p>
                <p className="text-xs tracking-[0.1em] uppercase text-[#D4AF37] font-semibold mt-1">{p.title}</p>
                <p className="mt-2 text-sm">{p.bio}</p>
              </div>
            ))}
          </div>
        </div>

        <div data-testid="leadership-open-roles-section">
          <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold">Compliance & Operations Leadership</p>
          <p className="mt-2 text-sm">
            Here is how compliance oversight and clinical-operations execution are structured at Acuity Rise. Named
            leaders are published as each seat completes onboarding, including standard conflict-of-interest screening.
          </p>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
            {LEADERSHIP_OPEN_ROLES.map((r) => (
              <div key={r.title} className="border border-[#E2E8F0] rounded-xl p-5" data-testid={`open-role-${r.title.replace(/\s+/g, "-").toLowerCase()}`}>
                <p className="font-serif text-base text-[#0B1B2B] font-semibold">{r.title}</p>
                <p className="mt-2 text-sm text-[#64748B] leading-relaxed">{r.function}</p>
                <p className="mt-2 text-xs text-[#94A3B8] leading-relaxed">{r.credentials}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          ["Discretion", "Every submission handled under encrypted intake and audit-logged access."],
          ["Rigor", "Primary-source verification and board-aligned documentation as standard."],
          ["Partnership", "Executive cadence reporting with named operational leads."],
        ].map(([t, d]) => (
          <div key={t} className="border-l-2 border-[#D4AF37] pl-4 py-1">
            <div className="font-serif text-lg text-[#0B1B2B] font-semibold">{t}</div>
            <div className="text-sm text-[#64748B] mt-1">{d}</div>
          </div>
        ))}
      </div>
    </div>
  </Modal>
);
